import { Box, Text } from "@chakra-ui/react";
import { IntegrationStatus } from "../../lib/interfaces/job-offer";

const STYLES: Record<IntegrationStatus, { color: string; backgroundColor: string; text: string }> = {
  [IntegrationStatus.ACTIVE]: { color: "green.500", backgroundColor: "green.100", text: "Aktiv" },
  [IntegrationStatus.INACTIVE]: { color: "red.500", backgroundColor: "red.100", text: "Inaktiv" },
  [IntegrationStatus.PENDING]: { color: "gray.500", backgroundColor: "gray.100", text: "Ausstehend" },
};

/** Status of one publication channel. A missing status (older backend) counts as inactive. */
export const ChannelStatusBadge = ({ status }: { status: IntegrationStatus | undefined }) => {
  const style = STYLES[status ?? IntegrationStatus.INACTIVE] ?? STYLES[IntegrationStatus.INACTIVE];

  return (
    <Box className="rounded-md px-2 py-1 w-fit" bg={style.backgroundColor} color={style.color}>
      <Text>{style.text}</Text>
    </Box>
  );
};
